export default {
    switchTab(state, tabName) {
        state.activeTab = tabName;
    }
}
